import * as types from './types';
import  update from  'immutability-helper';

interface ILog {
  id: number;
  description: string;
  createdAt: Date;
  username: string;
}

interface IDetail {
  id: number;
  description: string;
  createdAt: Date;
  creatorId: number;
  before: any;
  after: any;
  creator: {
    username: string;
  }
}

interface IState {
  logs: ILog[];
  detail: IDetail;
  loading: boolean;
  showDetail: boolean;
}

const initialState = {
  logs: [],
  detail: {},
  loading: false,
  showDetail: false,
}

const reducerMap: {
  [key in keyof typeof types]?: (state: IState, action: Partial<{ type: keyof typeof types }>) => IState;
} = Object.create(null);

reducerMap[types.SET_LOGS] = (state, action) =>  update(state, {
  logs: {$set: action.logs},
});

reducerMap[types.SET_DETAIL] = (state, action) => update(state, {
  detail: {$set: action.detail},
});

reducerMap[types.TOGGLE_LOADING] = (state, action) => update(state, {
  loading: {$set: action.status},
})

reducerMap[types.TOGGLE_DETAIL] = (state, action) => update(state, {
  showDetail: {$set: action.status},
})

export default (state = initialState, action) => (
  reducerMap[action.type]
    ? reducerMap[action.type](state, action)
    : state
);
